import { Phone, Mail, MapPin, ArrowRight } from "lucide-react";
import { IMAGES } from "@/data/content";
import { Reveal } from "./Reveal";

export default function ContactInfo() {
  const go = (href) => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="contact" className="py-24 md:py-32 px-6 md:px-10 bg-white" data-testid="contact-section">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <Reveal>
          <span className="text-xs font-semibold uppercase tracking-[0.25em] text-gold">Contact</span>
          <h2 className="mt-5 font-display text-4xl sm:text-5xl font-normal tracking-tight text-forest leading-[1.1]">
            Parlons de vos besoins
          </h2>
          <p className="mt-5 text-forest/70 leading-relaxed max-w-md">
            Notre équipe est à votre écoute pour répondre à toutes vos questions. Contactez-nous directement ou demandez à être rappelé gratuitement.
          </p>

          <div className="mt-10 space-y-5">
            {[
              { icon: Phone, label: "Téléphone", val: "06 99 26 07 05", href: "tel:0699260705" },
              { icon: Mail, label: "Email", val: "contact@proxiliasenior.com", href: "mailto:contact@proxiliasenior.com" },
              { icon: MapPin, label: "Zone d’intervention", val: "Lyon & alentours", href: null },
            ].map((c) => {
              const Inner = (
                <>
                  <div className="w-12 h-12 rounded-2xl bg-sage/12 flex items-center justify-center shrink-0">
                    <c.icon className="w-5 h-5 text-sage" strokeWidth={1.5} />
                  </div>
                  <div>
                    <div className="text-xs uppercase tracking-wider text-forest/45">{c.label}</div>
                    <div className="font-medium text-forest">{c.val}</div>
                  </div>
                </>
              );
              return c.href ? (
                <a key={c.label} href={c.href} className="flex items-center gap-4 group" data-testid={`contact-info-${c.label.toLowerCase()}`}>
                  {Inner}
                </a>
              ) : (
                <div key={c.label} className="flex items-center gap-4" data-testid={`contact-info-${c.label.toLowerCase()}`}>
                  {Inner}
                </div>
              );
            })}
          </div>

          <button
            onClick={() => go("#rappel")}
            className="group mt-10 inline-flex items-center gap-2 bg-forest text-cream px-8 py-4 rounded-full font-medium transition-all hover:bg-forestdark active:scale-[0.98]"
            data-testid="contact-to-callback"
          >
            Être rappelé
            <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
          </button>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="relative group rounded-[2rem] overflow-hidden h-[460px] shadow-[0_30px_60px_-20px_rgba(48,66,56,0.35)]">
            <img src={IMAGES.leisure} alt="Sortie accompagnée Proxilia" className="w-full h-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-105" />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
